import React from 'react';
import TextInput from 'components/inputs/TextInput';
import UserSearchInput from 'components/inputs/UserSearchInput';
import SwitchInput from 'components/inputs/SwitchInput';
import Button from 'components/common/Button';
import Form from 'components/common/Form';
import FormItem from 'components/common/FormItem';

class OrganizationForm extends React.PureComponent {
  state = {
    title: this.props.organization ? this.props.organization.title : null,
    description: this.props.organization ? this.props.organization.description : null,
    mainUser:
      this.props.organization && this.props.organization.mainUser
        ? {
          label: `${this.props.organization.mainUser.profile.firstName} ${
            this.props.organization.mainUser.profile.firstName
          }`,
          value: this.props.organization.mainUser._id,
        }
        : false,
    subscribed: this.props.organization ? this.props.organization.subscribed : false,
  };

  onChange = newValue => {
    this.setState(newValue);
  };

  onMainUserChange = user => {
    this.setState({
      mainUser: {
        value: user._id,
        label: `${user.profile.firstName} ${user.profile.firstName} - ${user.emails[0].address}`,
      },
    });
  };

  onSubmit = () => {
    // setup the details object we want to pass to the parent component
    let details = {
      title: this.state.title,
      description: this.state.description,
      subscribed: this.state.subscribed,
      mainUserId: this.state.mainUser.value,
    };
    // pass up the details to be used by the parent component (i.e. the component using this OrganizationForm)
    this.props.handleSubmit(details);
  };

  render() {
    return (
      <Form>
        <FormItem label="Title">
          <TextInput value={this.state.title} onChange={title => this.onChange({ title })} />
        </FormItem>
        <FormItem label="Description">
          <TextInput value={this.state.description} onChange={description => this.onChange({ description })} />
        </FormItem>
        <FormItem label="Main User">
          <UserSearchInput value={this.state.mainUser} onChange={this.onMainUserChange} />
        </FormItem>
        <FormItem label="Subscribed">
          <SwitchInput value={this.state.subscribed} onChange={subscribed => this.onChange({ subscribed })} />
        </FormItem>
        <FormItem>
          <Button onClick={this.onSubmit}>{this.props.buttonLabel}</Button>
        </FormItem>
      </Form>
    );
  }
}

OrganizationForm.defaultProps = {
  buttonLabel: 'Add Organization',
};

export default OrganizationForm;



// WEBPACK FOOTER //
// ./src/components/forms/OrganizationForm/index.js